// Invoice Form Controller
import { Controller } from "@hotwired/stimulus";

// Proposes the amounts of the purchase order chosen. Each option carries what
// its order has to invoice (`data-total`): the page used to ask a URL that never
// existed, at each choice, and would have applied a fixed 20 % (QA EXP4-05).
// Both amounts get what the order has to invoice (received and not billed
// yet, else its total), as when the form opens from an order;
// the tax is typed from the supplier's invoice.
export default class extends Controller {
  loadPurchaseOrderData(event) {
    const total = event.target.selectedOptions[0]?.dataset.total;

    if (!total) return;

    ["invoice_amount_excluding_tax", "invoice_amount_including_tax"].forEach((id) => {
      const field = document.getElementById(id);
      if (field) field.value = total;
    });
  }
}
